import About from "./components/About";
import AllinOne from "./components/AllinOne";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Narbar from "./components/Narbar";
import Priceing from "./components/Priceing";
import Support from "./components/Support";


function App() {
  return (
    <>
    <Narbar/>
    <Hero/>
    <About/>
    <Support/>
    <AllinOne/>
    <Priceing/>
    <Footer/>
    </>
  );
}

export default App;
